<template>

  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="6"
            :lg="6"
          >
          <Divider orientation="left">{{ langMap.workOrderList[lang] }}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="18"
            :lg="18"
          >
          <Form :label-width="80">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.workOrderNumber[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="orderNo"
                  :placeholder="langMap.workOrderNumber[lang]"
                  clearable
                />
              </FormItem>
              <FormItem
                :label="langMap.robot[lang]"
                class="leftFlex"
              >
                <Select
                  v-model="robotId"
                  clearable
                >
                  <Option
                    :key="item.id"
                    :value="item.id"
                    v-for="item in robotList"
                  >{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem
                :label="langMap.workOrderStatus[lang]"
                class="leftFlex"
              >
                <Select
                  v-model="status"
                  clearable
                >
                  <Option
                    :key="item.value"
                    :value="item.value"
                    v-for="item in statusList"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{ langMap.search[lang] }}</Button>
              <Button
                type="primary"
                style="margin-left:20px;"
                @click="modelShow(true, null)"
              >{{ langMap.add[lang] }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="col"
        :data="orderList"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="orderList.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="saveModal"
      width="65"
      :title="langMap.maintenanceWorkOrder[lang]"
    >
      <Form
        ref="formValidate"
        :model="saveForm"
        :rules="ruleValidate"
        :label-width="80"
      >
        <Row>
          <Col span="8">
          <FormItem
            :label="langMap.workOrderType[lang]"
            prop="orderType"
          >
            <Select v-model="saveForm.orderType">
              <Option
                :key="item.value"
                :value="item.value"
                v-for="item in orderTypes"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem
            :label="langMap.robot[lang]"
            prop="robotId"
          >
            <Select
              v-model="saveForm.robotId"
              :placeholder="langMap.pleaseInputName[lang]"
              clearable
            >
              <Option
                :key="item.id"
                :value="item.id"
                v-for="item in robotList"
              >{{ item.name }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem
            :label="langMap.faultTime[lang]"
            prop="happenTime"
          >
            <DatePicker
              @on-change="formatHappenTime"
              v-model="happenTimeDate"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :placeholder="langMap.faultTime[lang]"
              style="width: 100%"
            />
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem
            :label="langMap.equipmentStatus[lang]"
            prop="equipmentStatus"
          >
            <Select
              v-model="saveForm.equipmentStatus"
              :placeholder="langMap.equipmentStatus[lang]"
            >
              <Option
                :key="item.value"
                :value="item.value"
                v-for="item in equipmentStatusList"
              >{{ item.label }}
              </Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem
            :label="langMap.urgencyLevel[lang]"
            prop="urgentLevel"
          >
            <Select
              v-model="saveForm.urgentLevel"
              :placeholder="langMap.urgencyLevel[lang]"
            >
              <Option
                :key="item.value"
                :value="item.value"
                v-for="item in urgentLevels"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem
            :label="langMap.deadline[lang]"
            prop="deadline"
          >
            <DatePicker
              @on-change="formatDeadlineTime"
              v-model="deadlineDate"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              :placeholder="langMap.deadline[lang]"
              style="width: 100%"
            />
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <FormItem :label="langMap.maintenancePersonnel[lang]">
            <Input
              v-model="saveForm.repairUserName"
              :placeholder="langMap.maintenancePersonnel[lang]"
            />
          </FormItem>
          </Col>
          <Col span="16">
          <FormItem
            :label="langMap.workOrderDescription[lang]"
            prop="orderDescription"
          >
            <Input
              v-model="saveForm.orderDescription"
              type="textarea"
              :autosize="{minRows: 2,maxRows: 8}"
              :placeholder="langMap.workOrderDescription[lang]"
            />
          </FormItem>
          </Col>
        </Row>
        <table width="100%">
          <tr>
            <td class="detail-td-left">
              {{ langMap.maintenanceDetails[lang] }}
            </td>
            <td class="detail-td-right">
              <Button
                size="small"
                type="info"
                style="margin: 6px;"
                @click="showItemModal(true)"
              >{{ langMap.addDetails[lang] }}</Button>
              <Table
                :columns="itemCol"
                :data="repairOrderItems"
              ></Table>
            </td>
          </tr>
        </table>
      </Form>
      <div slot="footer">
        <Button
          type="text"
          :loading="btnLoading"
          @click="cancel"
        >{{ langMap.cancel[lang] }}</Button>
        <Button
          type="primary"
          :loading="btnLoading"
          @click="ok"
        >{{ langMap.save[lang] }}</Button>
      </div>
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="saveItemModal"
      :title="langMap.maintenanceItem[lang]"
    >
      <Form
        ref="formItemValidate"
        :model="saveItemForm"
        :rules="ruleItemValidate"
        :label-width="80"
      >
        <FormItem
          :label="langMap.moduleName[lang]"
          prop="moduleName"
        >
          <Input
            v-model.trim="saveItemForm.moduleName"
            :placeholder="langMap.moduleName[lang]"
          />
        </FormItem>
        <FormItem
          :label="langMap.maintenanceType[lang]"
          prop="repairType"
        >
          <Select v-model="saveItemForm.repairType">
            <Option
              :key="item.value"
              :value="item.value"
              v-for="item in repairTypes"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem
          :label="langMap.maintenanceQuantity[lang]"
          prop="repairNumber"
        >
          <InputNumber
            :min="1"
            v-model="saveItemForm.repairNumber"
            style="width: 100%"
          ></InputNumber>
        </FormItem>
        <FormItem
          :label="langMap.maintenanceAmount[lang]"
          prop="repairAmount"
        >
          <InputNumber
            :min="0.00"
            v-model="saveItemForm.repairAmount"
            style="width: 100%"
          ></InputNumber>
        </FormItem>
        <FormItem
          :label="langMap.remarks[lang]"
          prop="repairRemark"
        >
          <Input
            v-model="saveItemForm.repairRemark"
            type="textarea"
            :autosize="{minRows: 3,maxRows: 6}"
            :placeholder="langMap.remarks[lang]"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          type="text"
          :loading="btnLoading"
          @click="cancelItem"
        >{{ langMap.cancel[lang] }}</Button>
        <Button
          type="primary"
          :loading="btnLoading"
          @click="saveItem"
        >{{ langMap.confirm[lang] }}</Button>
      </div>
    </Modal>
    <Modal
      :mask-closable="false"
      v-model="showDetailModal"
      width="55"
      :title="langMap.robotInfo[lang]"
    >
      <Row>
        <Col span="8">
        <div class="detail-item">
          {{ langMap.workOrderNumber[lang] }}：{{ showDetailData.orderNo }}
        </div>
        </Col>
        <Col span="8">
        <div class="detail-item">
          {{ langMap.robot[lang] }}：{{ showDetailData.robotName }}
        </div>
        </Col>
        <Col span="8">
        <div class="detail-item detail-item-right">
          {{ langMap.workOrderType[lang] }}：
          <span v-if="showDetailData.orderType == 1">{{ langMap.repair[lang] }}</span>
          <span v-else-if="showDetailData.orderType == 2">{{ langMap.maintenance[lang] }}</span>
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="8">
        <div class="detail-item">
          {{ langMap.faultTime[lang] }}：{{ showDetailData.happenTime }}
        </div>
        </Col>
        <Col span="8">
        <div class="detail-item">
          {{ langMap.equipmentStatus[lang] }}：
          <span v-if="showDetailData.equipmentStatus == 1">{{ langMap.stopForRepair[lang] }}</span>
          <span v-else-if="showDetailData.equipmentStatus == 2">{{ langMap.normalOperation[lang] }}</span>
        </div>
        </Col>
        <Col span="8">
        <div class="detail-item detail-item-right">
          {{ langMap.urgencyLevel[lang] }}：
          <span v-if="showDetailData.urgentLevel == 1">{{ langMap.low[lang] }}</span>
          <span v-else-if="showDetailData.urgentLevel == 2">中</span>
          <span v-else-if="showDetailData.urgentLevel == 2">{{ langMap.high[lang] }}</span>
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="8">
        <div class="detail-item">
          {{ langMap.deadline[lang] }}：{{ showDetailData.deadline }}
        </div>
        </Col>
        <Col span="16">
        <div class="detail-item detail-item-right">
          {{ langMap.maintenancePersonnel[lang] }}：{{ showDetailData.repairUserName }}
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
        <div class="detail-item detail-item-right">
          {{ langMap.workOrderDescription[lang] }}：{{ showDetailData.orderDescription }}
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
        <div class="detail-item detail-item-right">
          {{ langMap.maintenanceDetails[lang] }}：
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
        <Table
          :columns="showDetailCol"
          :data="showDetailData.repairOrderItems"
        ></Table>
        </Col>
      </Row>
      <div slot="footer">
        <Button
          type="default"
          @click="cancelDetail"
        >{{ langMap.cancel[lang] }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      modal1: false,
      btnLoading: false,
      saveModal: false,
      saveItemModal: false,
      showDetailModal: false,
      showDetailData: {},
      orderList: [],
      robotList: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      orderNo: "",
      robotId: "",
      status: "",
      initSaveForm: {
        id: "",
        robotId: "",
        orderType: 1, //工单类型：1维修，2保养
        happenTime: "", //发生时间
        orderDescription: "",
        equipmentStatus: 1, //设备状态：1正常运行，2停机待维修，
        deadline: "", //工单截止时间
        urgentLevel: 1, //紧急程度：1低，2中，3高
        repairUserName: "", //维修/保养人员名称
        repairOrderItems: []
      },
      initItemForm: {
        id: "",
        moduleName: "",
        repairType: 1, //1维修，2更换
        repairNumber: 1,
        repairAmount: 0.0,
        repairRemark: "",
        _index: -1
      },
      
      saveItemForm: {
        id: "",
        moduleName: "",
        repairType: 1,
        repairNumber: 0,
        repairAmount: 0.0,
        repairRemark: "",
        _index: -1
      },
      
      saveForm: {
        id: "",
        robotId: "",
        orderType: 1, //工单类型：1维修，2保养
        happenTime: "", //发生时间
        orderDescription: "",
        equipmentStatus: 1, //设备状态：1正常运行，2停机待维修，
        deadline: "", //工单截止时间
        urgentLevel: 1, //紧急程度：1低，2中，3高
        repairUserName: "", //维修/保养人员名称
        repairOrderItems: []
      },
      repairOrderItems: [],
      
      happenTimeDate: "",
      deadlineDate: ""
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language 
    }),
    showDetailCol(){
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.moduleName[this.lang],
          key: "moduleName",
          width: 180
        },
        {
          title: langMap.maintenanceType[this.lang],
          key: "repairType",
          render:(h, params) => {
            var text = "";
            var color = "";
            if (params.row.repairType === 1) {
              text = langMap.repair[this.lang];
              color = "#ff9900";
            } else if (params.row.repairType === 2) {
              text = langMap.replace[this.lang];
              color = "red";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.maintenanceQuantity[this.lang],
          key: "repairNumber"
        },
        {
          title: langMap.maintenanceAmount[this.lang],
          key: "repairAmount"
        },
        {
          title: langMap.remarks[this.lang],
          key: "repairRemark"
        }
      ]
    },
    col () {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.workOrderNumber[this.lang],
          align: "center",
          width: 180,
          render: (h, params) => {
            let orderNo = params.row.orderNo;
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.showDetailModal = true;
                      this.showDetailData = { ...params.row };
                    }
                  }
                },
                orderNo
              )
            );
            return h("div", renderArray);
          }
        },
        {
          title: langMap.robot[this.lang],
          width: 100,
          key: "robotName"
        },
        {
          title: langMap.workOrderType[this.lang],
          width: 100,
          key: "orderType",
          render:(h, params)=> {
            var text = "";
            var color = "";
            if (params.row.orderType === 1) {
              text = langMap.repair[this.lang];
              color = "red";
            } else if (params.row.orderType === 2) {
              text = langMap.maintenance[this.lang];
              color = "#ff9900";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.happenTime[this.lang],
          key: "happenTime",
          width: 150
        },
        {
          title: langMap.workOrderStatus[this.lang],
          width: 100,
          key: "orderStatus",
          render:(h, params) =>{
            var text = "";
            var color = "";
            if (params.row.orderStatus === 0) {
              text = langMap.draft[this.lang];
              color = "#2db7f5";
            } else if (params.row.orderStatus === 1) {
              text = langMap.pending[this.lang];
              color = "#ff9900";
            } else if (params.row.orderStatus === 2) {
              text = langMap.processing[this.lang];
              color = "red";
            } else if (params.row.orderStatus === 3) {
              text = langMap.processed[this.lang];
              color = "green";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.workOrderDescription[this.lang],
          width: 250,
          key: "orderDescription",
          render: (h, params) => {
            return this.hideText(h, params.row.orderDescription, "300px");
          }
        },
        {
          title: langMap.equipmentStatus[this.lang],
          width: 100,
          key: "equipmentStatus",
          render:(h, params)=> {
            var text = "";
            var color = "";
            if (params.row.equipmentStatus === 1) {
              text = langMap.normalOperation[this.lang];
              color = "green";
            } else if (params.row.equipmentStatus === 2) {
              text = langMap.shutdownPending[this.lang];
              color = "red";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.deadline[this.lang],
          width: 150,
          key: "deadline"
        },
        {
          title: langMap.urgencyLevel[this.lang],
          width: 100,
          key: "urgentLevel",
          render:(h, params) =>{
            var text = "";
            var color = "";
            if (params.row.urgentLevel === 1) {
              text = langMap.low[this.lang];
              color = "green";
            } else if (params.row.urgentLevel === 2) {
              text = langMap.medium[this.lang];
              color = "#ff9900";
            } else if (params.row.urgentLevel === 3) {
              text = langMap.high[this.lang];
              color = "red";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.maintenancePersonnel[this.lang],
          width: 150,
          key: "repairUserName"
        },
        {
          title: langMap.createTime[this.lang],
          width: 150,
          key: "createTime",
          render:(h, params)=> {
            var text = "";
            if (params.row.createTime) {
              text = params.row.createTime;
            } else {
              text = "-";
            }
            return h("span", text);
          }
        },
        {
          title: langMap.updateTime[this.lang],
          width: 150,
          key: "updateTime",
          render:(h, params) =>{
            var text = "";
            if (params.row.updateTime) {
              text = params.row.updateTime;
            } else {
              text = langMap.noModification[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          align: "center",
          fixed: "right",
          width: 200,
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.showDetailModal = true;
                      this.showDetailData = { ...params.row };
                    }
                  }
                },
                langMap.view[this.lang]
              )
            );
            if (params.row.orderStatus != 3) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.modelShow(true, params.row);
                      }
                    }
                  },
                  langMap.modify[this.lang]
                )
              );
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
            }
            if (params.row.orderStatus != 3) {
              let text = "";
              let content = "";
              let status = 0;
              if (params.row.orderStatus === 0) {
                text = langMap.push[this.lang];
                content = langMap.confirmPushWorkOrder[this.lang];
                status = 1;
              } else if (params.row.orderStatus === 1) {
                text = langMap.process[this.lang];
                content = langMap.confirmProcessWorkOrder[this.lang];
                status = 2;
              } else if (params.row.orderStatus === 2) {
                text = langMap.finish[this.lang];
                content = langMap.confirmFinishWorkOrder[this.lang];
                status = 3;
              }
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: content,
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            const updateStatus = {
                              id: params.row.id,
                              orderStatus: status
                            };
                            api
                              .postData(
                                "robot-server/repair-order/status",
                                updateStatus,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  text
                )
              );
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmDelete[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "robot-server/repair-order/delete/" +
                                  params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.delete[this.lang]
                )
              );
            }

            return h("div", renderArray);
          }
        }
      ]
    },
    itemCol (){
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.moduleName[this.lang],
          key: "moduleName",
          width: 150
        },
        {
          title: langMap.maintenanceType[this.lang],
          key: "repairType",
          render:(h, params)=> {
            var text = "";
            var color = "";
            if (params.row.repairType === 1) {
              text = langMap.repair[this.lang];
              color = "#ff9900";
            } else if (params.row.repairType === 2) {
              text = langMap.replace[this.lang];
              color = "red";
            }
            return h(
              "span",
              {
                style: {
                  color: color
                }
              },
              text
            );
          }
        },
        {
          title: langMap.quantity[this.lang],
          key: "repairNumber"
        },
        {
          title: langMap.amount[this.lang],
          key: "repairAmount"
        },
        {
          title: langMap.remarks[this.lang],
          key: "repairRemark",
          render: (h, params) => {
            return this.hideText(h, params.row.repairRemark, "300px");
          }
        },
        {
          title: langMap.operation[this.lang],
          align: "center",
          width: 200,
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.showItemModal(true, params.row);
                    }
                  }
                },
                langMap.modify[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDeleteItem[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          if (params.row.id) {
                            this.$Spin.show();
                            api
                              .getData(
                                "robot-server/repair-order/item/delete/" +
                                  params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.repairOrderItems.splice(
                                    params.row._index,
                                    1
                                  );
                                }
                                this.$Spin.hide();
                              });
                          } else {
                            this.repairOrderItems.splice(params.row._index, 1);
                          }
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            return h("div", renderArray);
          }
        }
      ]
    },
    statusList(){
      return[
        {
          value: 0,
          label: langMap.draft[this.lang]
        },
        {
          value: 1,
          label: langMap.pending[this.lang]
        },
        {
          value: 2,
          label: langMap.processing[this.lang]
        },
        {
          value: 3,
          label: langMap.processed[this.lang]
        }
      ]
    },
    orderTypes() {
      return [
        {
          value: 1,
          label: langMap.repair[this.lang]
        },
        {
          value: 2,
          label: langMap.maintenance[this.lang]
        }
      ]
    },
    equipmentStatusList() {
      return [
        {
          value: 1,
          label: langMap.normalOperation[this.lang]
        },
        {
          value: 2,
          label: langMap.shutdownPending[this.lang]
        }
      ]
    },
    urgentLevels() {
      return [
        {
          value: 1,
          label: langMap.low[this.lang]
        },
        {
          value: 2,
          label: langMap.medium[this.lang]
        },
        {
          value: 3,
          label: langMap.high[this.lang]
        }
      ]
    },
    repairTypes(){
      return[
        {
          value: 1,
          label: langMap.repair[this.lang]
        },
        {
          value: 2,
          label: langMap.replace[this.lang]
        }
      ]
    },
    ruleItemValidate() {
      return {
        moduleName: [
          { required: true, message: langMap.moduleNameRequired[this.lang], trigger: "blur" },
          {
            type: "string",
            max: 30,
            message: langMap.moduleNameMaxLength[this.lang],
            trigger: "blur"
          }
        ],
        repairType: [
          {
            required: true,
            type: "number",
            message: langMap.maintenanceTypeRequired[this.lang],
            trigger: "change"
          }
        ],
        repairNumber: [
          {
            required: true,
            type: "number",
            message: langMap.enterValidNumber[this.lang],
            trigger: "blur"
          }
        ],
        repairAmount: [
          {
            required: true,
            type: "number",
            message: langMap.enterValidAmount[this.lang],
            trigger: "blur"
          }
        ],
        repairRemark: [
          {
            type: "string",
            max: 500,
            message: langMap.remarkMaxLength[this.lang],
            trigger: "blur"
          }
        ]
      }
    },
    ruleValidate() {
      return {
        orderType: [
          {
            required: true,
            type: "number",
            message: langMap.workOrderTypeRequired[this.lang],
            trigger: "change"
          }
        ],
        robotId: [
          {
            required: true,
            type: "number",
            message: langMap.robotRequired[this.lang],
            trigger: "change"
          }
        ],
        equipmentStatus: [
          {
            required: true,
            type: "number",
            message: langMap.robotRequired[this.lang],
            trigger: "change"
          }
        ],
        urgentLevel: [
          {
            required: true,
            type: "number",
            message: langMap.urgentLevelRequired[this.lang],
            trigger: "change"
          }
        ],
        orderDescription: [
          { required: true, message: langMap.descriptionRequired[this.lang], trigger: "blur" },
          {
            type: "string",
            min: 20,
            message: langMap.descriptionMinLength[this.lang],
            trigger: "blur"
          },
          {
            type: "string",
            max: 500,
            message: langMap.descriptionMaxLength[this.lang],
            trigger: "blur"
          }
        ],
        deadline: [
          { required: true, message: langMap.deadlineRequired[this.lang], trigger: "blur" }
        ]
      }
    },
  },
  methods: {
    cancelDetail() {
      this.showDetailModal = false;
    },
    showItemModal(flag, data) {
      if (data) {
        this.saveItemForm = { ...data };
        //设置时间格式
      } else {
        this.saveItemForm = { ...this.initItemForm };
      }
      this.saveItemModal = flag;
      this.$refs["formItemValidate"].resetFields();
    },
    hideText(h, text, width) {
      return h("div", [
        // 显示的位置上方
        h(
          "Tooltip",
          {
            props: { placement: "top", transfer: true }
          },
          [
            h(
              "span",
              {
                style: {
                  display: "inline-block",
                  width: width,
                  overflow: "hidden",
                  // 同样在这里隐藏溢出内容
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }
              },
              text
            ),
            // 显示的内容
            h(
              "span",
              {
                slot: "content",
                style: { whiteSpace: "normal", wordBreak: "break-all" }
              },
              text
            )
          ]
        )
      ]);
    },
    formatHappenTime(e) {
      this.saveForm.happenTime = e;
    },
    formatDeadlineTime(e) {
      this.saveForm.deadline = e;
    },
    //获取机器人列表
    getRobotList() {
      this.tableLoading = true;
      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data;
        }
        this.tableLoading = false;
      });
    },
    //获取列表
    getList() {
      this.tableLoading = true;
      api
        .getData(
          "robot-server/repair-order/list?index=" +
            this.index +
            "&robotId=" +
            (this.robotId || "") +
            "&orderNo=" +
            this.orderNo +
            "&status=" +
            (this.status || ""),
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.orderList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    modelShow(flag, data) {
      if (data) {
        this.saveForm = { ...data };
        if (this.saveForm.happenTime) {
          this.happenTimeDate = new Date(this.saveForm.happenTime);
        }
        if (this.saveForm.deadline) {
          this.deadlineDate = new Date(this.saveForm.deadline);
        }
        this.repairOrderItems = [...data.repairOrderItems];
      } else {
        this.saveForm = { ...this.initSaveForm };
        this.repairOrderItems = [];
        this.happenTimeDate = "";
        this.deadlineDate = "";
      }
      this.saveModal = flag;
      this.$refs["formValidate"].resetFields();
    },
    ok() {
      console.log(this.saveForm);
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          this.saveForm.repairOrderItems = this.repairOrderItems;
          api
            .postData("robot-server/repair-order/save", this.saveForm, this)
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.systemTip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.systemTip[this.lang],
                  desc: langMap.operationSuccess[this.lang]
                });
                this.getList();
                this.saveModal = false;
              }
            });
        }
      });
    },
    cancel() {
      this.saveModal = false;
    },
    cancelItem() {
      this.saveItemModal = false;
    },
    saveItem() {
      console.log(this.saveItemForm);
      this.$refs["formItemValidate"].validate(valid => {
        if (valid) {
          const item = { ...this.saveItemForm };
          if (item._index != -1) {
            this.repairOrderItems[item._index] = item;
          } else {
            this.repairOrderItems.push(item);
          }
          const items = JSON.parse(JSON.stringify(this.repairOrderItems));
          this.repairOrderItems = items;
          this.saveItemModal = false;
        }
      });
    }
  },
  created() {
    this.getRobotList();
    this.getList();
  }
};
</script>

<style>
.detail-item {
  border-top: 1px solid #e8eaec;
  /*border-bottom: 1px solid #e8eaec;*/
  border-left: 1px solid #e8eaec;
  line-height: 30px;
  padding-bottom: 2px;
  padding-left: 8px;
}

.detail-item-right {
  border-right: 1px solid #e8eaec;
}

.detail-td-left {
  padding: 4px;
  width: 75px;
  text-align: center;
  border-left: 1px solid #e8eaec;
  border-top: 1px solid #e8eaec;
  border-bottom: 1px solid #e8eaec;
}
.detail-td-right {
  padding: 4px;
  width: calc(100% - 75px);
  border: 1px solid #e8eaec;
  /*border-top: 1px solid #e8eaec;*/
  /*border-bottom: 1px solid #e8eaec;*/
  /*border-left: ;*/
}
</style>
